import { createFileRoute } from '@tanstack/react-router';

import { EnlistmentsPage } from '@/features/employers';

export const Route = createFileRoute('/_app/employers/enlistments')({
  staticData: { crumb: 'nav.enlistments' },
  component: EnlistmentsPage,
});
